import Vue from "vue";


import DpHeader from "../components/dp-header";
import DpCount from "../components/dp-count";
import AMap from "../components/AMap";
// import DpThreeMap from "../components/dp-three-map.vue"; // old threeJs 打点连线地球
import DpThreeMap from "@/components/3dmap/threeMap.vue"; // new 打点展示弹窗地球
import navigation from "@/components/navigation";
import chat from "@/components/chat.vue";
import chatResponse from "@/components/chatResponse.vue";
import DpLayout from "@/components/dp-layout";
import buttonList from "@/components/buttonList.vue";
import buttonSwitching from "@/components/buttonSwitching.vue";
import ThreatMask from "@/components/threat-mask.vue";
import mapData from "@/components/mapData.vue";
import worldMapData from "@/components/worldMapData.vue";
import chinaMap from "@/components/chinaMap.vue";
import generalWorldMapData from "@/components/generalWorldMapData.vue";
import threeGeneralWorldMapData from "@/components/generalWorldMapData.vue";


import chartOne from "@/components/sideScreen/chartOne.vue";
import chartTwo from "@/components/sideScreen/chartTwo.vue";
import chartThree from "@/components/sideScreen/chartThree.vue";
import chartFour from "@/components/sideScreen/chartFour.vue";
import chartFive from "@/components/sideScreen/chartFive.vue";

import vulDetectionTrend from "@/components/sideScreen/vulDetectionTrend.vue";
import vulReportStatusTable from "@/components/sideScreen/vulReportStatusTable.vue";
import recentAlarmEvent from "@/components/sideScreen/recentAlarmEvent.vue";

import countryViewSafetyDeploy from "@/components/sideScreen/countryViewSafetyDeploy.vue";
import dnssecDeploy from "@/components/sideScreen/dnssecDeploy.vue";
import dotDeploy from "@/components/sideScreen/dotDeploy.vue";
import dohDeploy from "@/components/sideScreen/dohDeploy.vue";

import newAttackMethod from "@/components/sideScreen/newAttackMethod.vue";
import effectedInstitutionThreat from "@/components/sideScreen/effectedInstitutionThreat.vue";
import effectedCountryDistribution from "@/components/sideScreen/effectedCountryDistribution.vue";
import mov from "@/components/sideScreen/mov.vue";

import knowledgeGraphDataSources from "@/components/sideScreen/knowledgeGraphDataSources.vue";
import ontologyStructureKnowledgeGraph from "@/components/sideScreen/ontologyStructureKnowledgeGraph.vue";
import topo from "@/components/sideScreen/topo.vue";
import searchTopo from "@/components/sideScreen/searchTopo.vue";
import newVulnerabilityList from "@/components/sideScreen/newVulnerabilityList.vue";


Vue.component("DpHeader", DpHeader);
Vue.component("DpCount", DpCount);
Vue.component("AMap", AMap);
Vue.component("DpThreeMap", DpThreeMap);
Vue.component("navigation", navigation);
Vue.component("dp-chat", chat);
Vue.component("chatResponse", chatResponse);
Vue.component("DpLayout", DpLayout);
Vue.component("buttonList", buttonList);
Vue.component("ThreatMask", ThreatMask);
Vue.component("buttonSwitching", buttonSwitching);
Vue.component("mapData",mapData);
Vue.component("worldMapData",worldMapData);
Vue.component("chinaMap",chinaMap);
Vue.component("generalWorldMapData",generalWorldMapData);
Vue.component("threeGeneralWorldMapData",threeGeneralWorldMapData);


Vue.component("chartOne", chartOne);
Vue.component("chartTwo", chartTwo);
Vue.component("chartThree", chartThree);
Vue.component("chartFour", chartFour);
Vue.component("chartFive", chartFive);

Vue.component("vulDetectionTrend", vulDetectionTrend);
Vue.component("vulReportStatusTable", vulReportStatusTable);
Vue.component("recentAlarmEvent", recentAlarmEvent);

Vue.component("countryViewSafetyDeploy", countryViewSafetyDeploy);
Vue.component("dnssecDeploy", dnssecDeploy);
Vue.component("dotDeploy", dotDeploy);
Vue.component("dohDeploy", dohDeploy);

Vue.component("newAttackMethod", newAttackMethod);
Vue.component("effectedInstitutionThreat", effectedInstitutionThreat);
Vue.component("effectedCountryDistribution", effectedCountryDistribution);
Vue.component("mov",mov);

Vue.component("knowledgeGraphDataSources",knowledgeGraphDataSources);
Vue.component("ontologyStructureKnowledgeGraph",ontologyStructureKnowledgeGraph);
Vue.component("topo",topo);
Vue.component("searchTopo",searchTopo);
Vue.component("newVulnerabilityList",newVulnerabilityList);



